import { Polygon } from "geojson";

export const enum SidebarEnum {
  MISSIONS = "missions",
  SITES = "sites",
  SETTINGS = "settings",
}

export type MissionType = {
  mission_num2: string;
  responsable1: string;
  responsable2: string;
  lieu: string;
  title: string;
  url: string;
  sites_nb: number;
  site_ids: string;
  latitude: number;
  longitude: number;
  countries: string;
  geometry: Polygon;
};

export type SiteType = {
  site_id: number;
  site: string;
  points: number;
  missions: string;
  country: string;
  latitude: number;
  longitude: number;
  altitude: number;
  site_geom: string;
  buffer_geom: string;
};
